// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》';
// 在哪个组件上监听事件， 方法就该写在哪个组件上，但是如果方法里执行的是其他extendJS 里的方法，就不是自有方法
// import {
//   storeGet,
//   storeSet,
//   storeRm,
//   lockrFlush
// } from '@/tools/lockr';

import {
  storeGet,
  storeSet,
  storeRm
} from '@/tools/hukeStore'

const origin_error_text = '您的账户未与满班课程顾问绑定，无法访问满班数据'

import { hukeAutoLogin } from '@/service/util'
export default {
  // import引入的组件需要注入到对象中才能使用
  components: {},
  data () {
    // 这里存放数据
    return {
      act_index: 0, // 默认从第零步开始（）， 第0步则是说明有报错信息
      manban_auto_login_loading: true,
      empty_error_text: ''
    }
  },
  // 监听属性 类似于data概念
  computed: {},
  // 监控data中的数据变化
  watch: {
    // '$route.query': {
    //   handler: function(newVal, oldVal){
    //     this.initGetCipherText()
    //   },
    //   deep: true
    // }
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created () {

  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted () {

  },
  beforeCreate () {}, // 生命周期 - 创建之前
  beforeMount () {}, // 生命周期 - 挂载之前
  beforeUpdate () {}, // 生命周期 - 更新之前
  updated () {}, // 生命周期 - 更新之后
  beforeDestroy () {
    // for (const key in this.$refs) {
    //  this.$refs[key].$destroy()
    // }
  }, // 生命周期 - 销毁之前
  destroyed () {}, // 生命周期 - 销毁完成
  activated () {}, // 如果页面有keep-alive缓存功能，这个函数会触发
  // 方法集合
  methods: {
    /* 自有方法， 和其他不相关连的---- 在哪个组件上监听事件， 方法就该写在哪个组件上，但是如果方法里执行的是其他extendJS 里的方法，就不是自有方法 */
    initGetCipherText () {
      return new Promise(async (resolve, reject) => {
        const route = this.$route || {}

        const query = route.query || {}

        const ciphertext = query.ciphertext || ''

        const app_key = query.huke_app_key || ''

        console.log(ciphertext, 'init get ciphertext')
        console.log(app_key, 'init get app_key')

        console.log(query, 'init query')

        if (ciphertext) {
          const queryStrIndex = ciphertext.indexOf('?')
          const new_ciphertext = queryStrIndex > -1 ? ciphertext.slice(0, queryStrIndex) : ciphertext
          console.log(new_ciphertext, 'new_ciphertext')
          storeSet('ciphertext', new_ciphertext)

          // return ;
        } else { // 兼容写法 网易互客app端有bug, 已反馈但不是立即修复
          const origin_location_href = window.location.href || ''
          const location_href = origin_location_href ? decodeURIComponent(origin_location_href) : ''

          // console.log(location_href, 'empty ciphertext')
          // console.log(location_href.match(/ciphertext=/i)[0], 'location_href match')

          const location_href_match = location_href.match(/ciphertext=/i)

          if (location_href && location_href_match && location_href_match[0]) { // 但有密文
            console.log(location_href, 'location_href ciphertext=')

            // 发生场景 网易互客在app端（Android、ios都有），将密文拼接在 hash 路径之前
            // 现有例子 http://localhost:8083/?ciphertext=MjdBRDY4NjUwNzkzODNEM0M4NkFDRERCOTlBQTVDMERERTcyQkEzRTgyODNEMEY3NTAzRkU5REZBOUU2QzA4QTIzRDM0QjY0NUUzM0NERTI0QjQ2RDdCMEIxQTZDNzVCQkYyODAwNzhDNjEwQTEyMzdDQzM3QjBENERBMzlFMEEyN0U1MDFFNDJFRDE4RjY4MjAzQkZEQjMzOTVFMDI0NkRGOUU1NDhBNDQ2Q0NBQUU1MTg3OURFQUZEMjFFMUZCRkM3MjkxQkRENURDNDFGQ0M1MUEyQTA4RDM3OTVCQzg4M0FCMkRBQkYzNTNFQjY3QUZDNzc2NzBBMTVFM0VEREEwMzlBNThGRjI0MDc5MDFFOUEyQTBCQjkzMTVGQjZGQ0I1QjBGRkMxRDNBN0Y5NTMzOTg4QzBBMjZDMTc5MDg%3D#/arrange-audition?huke_app_key=3751391cb688493e94c97e41e98fe6c5
            location_href.replace(/ciphertext=(.*?)#+/i, (val, ciphertext) => {
              // ciphertext = decodeURIComponent(ciphertext)

              console.log(val, 'val ciphertext')

              console.log(ciphertext, 'replace ciphertext')

              if (ciphertext) {
                storeSet('ciphertext', ciphertext)

                // return;
              }
            })

            if (!storeGet('ciphertext')) {
              // 再次兼容有其他情况 1、https://{host}/xx/#/xx?{custom_key}=xx?cipther=xx
              // 例子：http://{host}/#/arrange-audition?huke_app_key=3751391cb688493e94c97e41e98fe6c5?ciphertext=MjdBRDY4NjUwNzkzODNEM0M4NkFDRERCOTlBQTVDMERERTcyQkEzRTgyODNEMEY3NTAzRkU5REZBOUU2QzA4QTIzRDM0QjY0NUUzM0NERTI0QjQ2RDdCMEIxQTZDNzVCQkYyODAwNzhDNjEwQTEyMzdDQzM3QjBENERBMzlFMEEyN0U1MDFFNDJFRDE4RjY4MjAzQkZEQjMzOTVFMDI0NkRGOUU1NDhBNDQ2Q0NBQUU1MTg3OURFQUZEMjFFMUZCRkM3MjkxQkRENURDNDFGQ0M1MUEyQTA4RDM3OTVCQzg4M0FCMkRBQkYzNTNFQjY3QUZDNzc2NzBBMTVFM0VEREEwMzlBNThGRjI0MDc5MDFFOUEyQTBCQjkzMTVGQjZGQ0I1QjBGRkMxRDNBN0Y5NTMzOTg4QzBBMjZDMTc5MDg=
              // 2、https://{host}/xx/#/xx?cipther=xx?{custom_key}=xx
              // 例子：http://{host}/#/arrange-audition?ciphertext=MjdBRDY4NjUwNzkzODNEM0M4NkFDRERCOTlBQTVDMERERTcyQkEzRTgyODNEMEY3NTAzRkU5REZBOUU2QzA4QTIzRDM0QjY0NUUzM0NERTI0QjQ2RDdCMEIxQTZDNzVCQkYyODAwNzhDNjEwQTEyMzdDQzM3QjBENERBMzlFMEEyN0U1MDFFNDJFRDE4RjY4MjAzQkZEQjMzOTVFMDI0NkRGOUU1NDhBNDQ2Q0NBQUU1MTg3OURFQUZEMjFFMUZCRkM3MjkxQkRENURDNDFGQ0M1MUEyQTA4RDM3OTVCQzg4M0FCMkRBQkYzNTNFQjY3QUZDNzc2NzBBMTVFM0VEREEwMzlBNThGRjI0MDc5MDFFOUEyQTBCQjkzMTVGQjZGQ0I1QjBGRkMxRDNBN0Y5NTMzOTg4QzBBMjZDMTc5MDg=?huke_app_key=3751391cb688493e94c97e41e98fe6c5
              location_href.replace(/ciphertext=(.*?)$/i, (val, ciphertext) => {
                // ciphertext = decodeURIComponent(ciphertext)

                console.log(val, 'val ciphertext')

                console.log(ciphertext, 'replace ciphertext')

                if (ciphertext) {
                  storeSet('ciphertext', ciphertext)

                  // return ;
                }
              })
            }
          }
        }

        if (app_key) {
          const queryStrIndex = app_key.indexOf('?')
          const new_app_key = queryStrIndex > -1 ? app_key.slice(0, queryStrIndex) : app_key

          console.log(new_app_key, 'new_app_key loading')

          storeSet('app_key', new_app_key)

          // return ;
        } else { // 兼容写法 网易互客app端有bug, 已反馈但不是立即修复
          const origin_location_href = window.location.href || ''
          const location_href = origin_location_href ? decodeURIComponent(origin_location_href) : ''

          // console.log(location_href, 'location_href huke_app_key=')
          // console.log(location_href.match(/huke_app_key=/i)[0], 'location_href match')

          const location_href_match = location_href.match(/huke_app_key=/i)

          if (location_href && location_href_match && location_href_match[0]) { // 但有app_key
            // 发生场景 网易互客在app端（Android、ios都有），将密文拼接在 hash 路径之前
            // 现有例子 http://localhost:8083/?ciphertext=MjdBRDY4NjUwNzkzODNEM0M4NkFDRERCOTlBQTVDMERERTcyQkEzRTgyODNEMEY3NTAzRkU5REZBOUU2QzA4QTIzRDM0QjY0NUUzM0NERTI0QjQ2RDdCMEIxQTZDNzVCQkYyODAwNzhDNjEwQTEyMzdDQzM3QjBENERBMzlFMEEyN0U1MDFFNDJFRDE4RjY4MjAzQkZEQjMzOTVFMDI0NkRGOUU1NDhBNDQ2Q0NBQUU1MTg3OURFQUZEMjFFMUZCRkM3MjkxQkRENURDNDFGQ0M1MUEyQTA4RDM3OTVCQzg4M0FCMkRBQkYzNTNFQjY3QUZDNzc2NzBBMTVFM0VEREEwMzlBNThGRjI0MDc5MDFFOUEyQTBCQjkzMTVGQjZGQ0I1QjBGRkMxRDNBN0Y5NTMzOTg4QzBBMjZDMTc5MDg%3D#/arrange-audition?huke_app_key=3751391cb688493e94c97e41e98fe6c5

            // 再次兼容有其他情况 1、https://{host}/xx/#/xx?{custom_key}=xx?cipther=xx
            // 例子：http://{host}/#/arrange-audition?huke_app_key=3751391cb688493e94c97e41e98fe6c5?ciphertext=MjdBRDY4NjUwNzkzODNEM0M4NkFDRERCOTlBQTVDMERERTcyQkEzRTgyODNEMEY3NTAzRkU5REZBOUU2QzA4QTIzRDM0QjY0NUUzM0NERTI0QjQ2RDdCMEIxQTZDNzVCQkYyODAwNzhDNjEwQTEyMzdDQzM3QjBENERBMzlFMEEyN0U1MDFFNDJFRDE4RjY4MjAzQkZEQjMzOTVFMDI0NkRGOUU1NDhBNDQ2Q0NBQUU1MTg3OURFQUZEMjFFMUZCRkM3MjkxQkRENURDNDFGQ0M1MUEyQTA4RDM3OTVCQzg4M0FCMkRBQkYzNTNFQjY3QUZDNzc2NzBBMTVFM0VEREEwMzlBNThGRjI0MDc5MDFFOUEyQTBCQjkzMTVGQjZGQ0I1QjBGRkMxRDNBN0Y5NTMzOTg4QzBBMjZDMTc5MDg=
            // 2、https://{host}/xx/#/xx?cipther=xx?{custom_key}=xx
            // 例子：http://{host}/#/arrange-audition?ciphertext=MjdBRDY4NjUwNzkzODNEM0M4NkFDRERCOTlBQTVDMERERTcyQkEzRTgyODNEMEY3NTAzRkU5REZBOUU2QzA4QTIzRDM0QjY0NUUzM0NERTI0QjQ2RDdCMEIxQTZDNzVCQkYyODAwNzhDNjEwQTEyMzdDQzM3QjBENERBMzlFMEEyN0U1MDFFNDJFRDE4RjY4MjAzQkZEQjMzOTVFMDI0NkRGOUU1NDhBNDQ2Q0NBQUU1MTg3OURFQUZEMjFFMUZCRkM3MjkxQkRENURDNDFGQ0M1MUEyQTA4RDM3OTVCQzg4M0FCMkRBQkYzNTNFQjY3QUZDNzc2NzBBMTVFM0VEREEwMzlBNThGRjI0MDc5MDFFOUEyQTBCQjkzMTVGQjZGQ0I1QjBGRkMxRDNBN0Y5NTMzOTg4QzBBMjZDMTc5MDg=?huke_app_key=3751391cb688493e94c97e41e98fe6c5
            console.log(location_href, 'location_href huke_app_key=')
            location_href.replace(/huke_app_key=(.*?)$/i, (val, huke_app_key) => {
              // huke_app_key = decodeURIComponent(huke_app_key)
              console.log(val, 'val huke_app_key')
              console.log(huke_app_key, 'replace huke_app_key')

              if (huke_app_key) {
                storeSet('app_key', huke_app_key)

                // return ;
              }
            })
          }
        }

        const { success } = await this.initLoginByCipherText()

        console.log(storeGet('ciphertext'), 'ciphertext after')
        console.log(storeGet('app_key'), 'app_key after')

        resolve({
          ciphertext: storeGet('ciphertext') || '',
          app_key: storeGet('app_key') || '',
          success
        })
      })
    },

    // 初始化登录
    initLoginByCipherText () {
      return new Promise(async (resolve, reject) => {
        const cipherText = storeGet('ciphertext') || ''

        console.log(cipherText, 'ciphertext')

        const app_key = storeGet('app_key') || ''

        if (cipherText && app_key) {
          const {
            success = false
          } = await this.autoLoginByCiphertext({ cipherText, app_key })

          resolve({
            success
          })
        } else {
          this.act_index = 0,
          this.manban_auto_login_loading = false

          this.empty_error_text = '信息缺失，请检查链接是否正确'

          reject({
            error: '信息缺失'
          })
        }

        this.$off('hock:beforeDestroy', this.flushLockr)

        this.$once('hock:beforeDestroy', this.flushLockr)
      })
    },

    // 自动登录ciphertext
    autoLoginByCiphertext ({ cipherText, app_key }) {
      return new Promise((resolve, reject) => {
        if (cipherText && app_key) {
          // storeRm('ciphertext')
          // storeRm('app_key')

          console.log('remove after ciphertext', storeGet('ciphertext'))
          console.log('remove after app_key', storeGet('app_key'))

          const params = {
            ciphertext: cipherText,
            huke_app_key: app_key
          }

          hukeAutoLogin((res) => {
            const { auth_token: token, profile, current_org_id } = res || {}

            if (token) {
              // storeSet('huke_token', token)

              try {
                this.$cookies.set('token', token)

                // storeSet('huke_token', token)
              } catch (err) {
                console.log(err, '使用 cookies 存储报错')
              }
            }

            if (profile) {
              storeSet('huke_profile', profile)
              // const { org } = profile || {}

              // if (org.id) {
              //   storeSet('org_id', org.id)
              // }
            }

            if (current_org_id) {
              // storeSet('huke_org_id', current_org_id)

              try {
                this.$cookies.set('orgid', current_org_id)

                // storeSet('huke_org_id', current_org_id)
              } catch (err) {
                console.log(err, '使用 cookies 存储报错')
              }
            }

            const act_index = this.act_index

            if (!act_index) { // 为错误页面时候
              this.act_index = 1
            }

            if (current_org_id && token) {
              resolve({
                success: true,
                org_id: current_org_id,
                token,
                profile: {
                  ...(profile || {})
                }
              })
            } else {
              reject({
                error: '登录成功，信息缺失'
              })
            }

            this.manban_auto_login_loading = false
          }, {
            ...params
          }, (err) => {
            console.log(err, 'err')
            const { response } = err || {}

            const { data } = response || {}

            const { error } = data || {}

            console.log(error, 'error')

            this.act_index = 0
            this.manban_auto_login_loading = false

            this.empty_error_text = error || origin_error_text
          })
        } else {
          this.act_index = 0
          this.manban_auto_login_loading = false

          // window.location.href

          const complete_href = ''

          this.empty_error_text = `获取登录信息出错，请刷新页面重试href:${complete_href}`

          reject({
            error: '页面信息错误'
          })
        }
      })
    },

    // 关闭则清空lockr
    flushLockr () {
      storeRm('ciphertext')
      storeRm('app_key')
      // lockrFlush()
    }
    /* 当前页面 功能事件函数复用方法 */
  }
}
